import { Popover } from "@mui/material";
import { Box } from "@mui/system";
import { MessageContent } from "./MessageContent";
import { SettingContent } from "./SettingContent";

export const PopoverBase = ({ open, handleClose, anchorEl, content }) => {
	const contentSwitch = () => {
		switch (content) {
			case "settings":
				return <SettingContent open={open} handleClose={handleClose} />;

			case "messages":
				return <MessageContent />;

			default:
				break;
		}
	};

	return (
		<Popover
			open={open}
			onClose={handleClose}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "right"
			}}
			anchorReference="anchorEl"
			transformOrigin={{
				vertical: "top",
				horizontal: "left"
			}}
			PaperProps={{
                sx: {
                    maxWidth: '90vw',
                    maxHeight: '80vh',
                    overflow: 'auto'
                }
            }}
		>
			<Box
				sx={{
					padding: "20px",
					minWidth:
						"250px"
				}}
			>
				{contentSwitch()}
			</Box>
		</Popover>
	);
};
